// Central data-testid registry for Kay's Waste Clearance
export const NAV = {
  logo: "nav-logo",
  linkWhy: "nav-link-why",
  linkServices: "nav-link-services",
  linkAreas: "nav-link-areas",
  linkPricing: "nav-link-pricing",
  linkAbout: "nav-link-about",
  linkFaq: "nav-link-faq",
  bookNowBtn: "nav-book-now-btn",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  root: "hero-section",
  ctaPrimary: "hero-cta-book",
  ctaSecondary: "hero-cta-pricing",
  trustBadge: "hero-trust-badge",
};

export const PRICING = {
  root: "pricing-section",
  card: (key) => `pricing-card-${key}`,
  bookBtn: (key) => `pricing-book-btn-${key}`,
};

export const CHECKOUT = {
  root: "checkout-page",
  loadSummary: "checkout-load-summary",
  loadSelect: "checkout-load-select",
  serviceSelect: "checkout-service-select",
  name: "checkout-name",
  email: "checkout-email",
  phone: "checkout-phone",
  addressNumber: "checkout-address-number",
  road: "checkout-address-road",
  town: "checkout-address-town",
  postcode: "checkout-address-postcode",
  date: "checkout-date",
  time: "checkout-time",
  notes: "checkout-notes",
  insuranceNotice: "checkout-insurance-notice",
  payBtn: "checkout-pay-btn",
};

export const CHECKOUT_SUCCESS = {
  root: "checkout-success-page",
  status: "checkout-status",
};

export const FAQ = {
  root: "faq-section",
  item: (i) => `faq-item-${i}`,
};

export const FOOTER = {
  root: "footer",
  licensedBadge: "footer-licensed-badge",
};
